import React from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import { Button, Card, CardBody, Col, FormGroup } from 'reactstrap';
import ReduxFormInput from '@Utils/ReduxFormInput';
import validate, { CreateUserBugReportParams } from './user-bug-report.validate';
import { AppState } from '@Redux/store';
import ReduxFormSelect from '@Utils/ReduxFormSelect';
import ReduxFormTextarea from '@Utils/ReduxFormTextarea';
import { ReasonTypeView } from '@Selectors/user/view/reason-type.view';
import { UnitView } from '@Selectors/user/view/unit.view';
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

interface FormProps {
  reasonTypes: ReasonTypeView[];
  armyId: number
  units: UnitView[];
  cancel: () => void;
  onSubmit: (values: any) => void;
  canSubmit: boolean;
}

const Form: React.FC<Props & InjectedFormProps<CreateUserBugReportParams, Props>> = (
  {
    reasonTypes,
    units,
    unitOptions,
    cancel,
    handleSubmit,
    canSubmit,
  }
) => {
  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <CardBody>
          <h4 className="text-center"><FormattedMessage {...defaultMessages.userUserBugReportNewTitle} /></h4>

          <FormGroup row={true}>
            <Col xs="12">
              <Field
                name="reasonType"
                type="text"
                datas={reasonTypes}
                noValue={false}
                component={ReduxFormSelect}
                label={defaultMessages.userUserBugReportFormReasonTypeTitle}
                placeHolder={defaultMessages.userUserBugReportFormReasonTypePlaceholder}
              />
            </Col>
          </FormGroup>

          <FormGroup row={true}>
            <Col xs="12">
              <Field
                name="report"
                type="text"
                component={ReduxFormTextarea}
                label={defaultMessages.userUserBugReportFormReportTitle}
                placeHolder={defaultMessages.userUserBugReportFormReportPlaceholder}
              />
            </Col>
          </FormGroup>

          <FormGroup row={true}>
            <Col xs="12">
              <Field
                name="unitId"
                type="text"
                datas={units}
                component={ReduxFormSelect}
                label={defaultMessages.userUserBugReportFormUnitIdTitle}
                placeHolder={defaultMessages.userUserBugReportFormUnitIdPlaceholder}
              />
            </Col>
          </FormGroup>

          <FormGroup row={true}>
            <Col xs="12">
              <Field
                name="unitOptionId"
                type="text"
                datas={unitOptions ?? []}
                component={ReduxFormSelect}
                label={defaultMessages.userUserBugReportFormUnitOptionIdTitle}
                placeHolder={defaultMessages.userUserBugReportFormUnitOptionIdPlaceholder}
              />
            </Col>
          </FormGroup>

          <FormGroup row={true}>
            <Col xs="12">
              <Field
                name="value"
                type="text"
                component={ReduxFormInput}
                label={defaultMessages.userUserBugReportFormValueTitle}
                placeHolder={defaultMessages.userUserBugReportFormValuePlaceholder}
              />
            </Col>
          </FormGroup>
        </CardBody>
        <div className="mb-2 text-center">
          <Button disabled={!canSubmit} onClick={() => cancel()} color="age"
                  type="button"><FormattedMessage {...defaultMessages.formCancel} /></Button>
          <Button disabled={!canSubmit} color="age" type="submit"><FormattedMessage {...defaultMessages.formSend} /></Button>
        </div>
      </Card>
    </form>
  );
};

const UserBugReportForm = reduxForm<CreateUserBugReportParams, Props>({
  form: 'create_user_bug_report',
  validate
})(Form);


const selector = formValueSelector('create_user_bug_report')


const mapStateToProps = (state: AppState, props: FormProps) => {

  const unit = props.units.find(u => u.id === selector(state, 'unitId')) ?? null;

  return {
    onSubmit: props.onSubmit,
    unitOptions: unit?.unitOptions ?? [],
    initialValues: {
      armyId: props.armyId
    }
  };
};


type Props = ReturnType<typeof mapStateToProps> &
  FormProps

export default connect(mapStateToProps)(UserBugReportForm);
